import Button from 'atoms/button';
import TermsLabel from 'organisms/AddNewCard/TermsLabel';
import { DefaultPaymentMethod } from 'organisms/DefaultPaymentMethod';

export function DefaultCard({
  onChangePaymentMethod,
  onSubmit,
  primaryButtonText,
}) {
  return (
    <>
      <div className="mobile-page-container">
        <div className="flex-row justify-between mb-15">
          <p className="bold f18">Default payment method</p>
          <button
            className="text-orange pointer f14 no-style-btn"
            onClick={onChangePaymentMethod}
          >
            Change
          </button>
        </div>
        <DefaultPaymentMethod />
      </div>
      <div className="mobile-main-action-btn">
        <Button
          onClick={onSubmit}
          className="mt-32 w-100"
          size="medium"
          text={primaryButtonText}
        />
        <TermsLabel />
      </div>
    </>
  );
}
